// ─── Feuille COMPACTE : renommer un cours de l'EDT ────────────────
// Appui long → « Modifier » : nom + salle SEULEMENT, sans toucher aux
// horaires (la fiche complète reste accessible par un tap sur le cours).
import React, { useEffect, useMemo, useState } from 'react';
import { Text, TextInput, StyleSheet } from 'react-native';
import { Feuille, stylesForm, useUI, useT } from '@mop/core';

export default function FeuilleNomSalleEDT({ visible, initial, onEnregistrer, onFermer }) {
  const UI = useUI();
  const t = useT();
  const s = useMemo(() => makeStyles(UI), [UI]);
  const [nom, setNom] = useState('');
  const [matiere, setMatiere] = useState('');
  const [salle, setSalle] = useState('');

  useEffect(() => {
    if (!visible) return;
    setNom(initial?.nom || '');
    setMatiere(initial?.matiere || '');
    setSalle(initial?.salle || '');
  }, [visible, initial]);

  const modifie = (!!nom.trim() || !!matiere.trim())
    && (matiere.trim() !== (initial?.matiere || '') || salle.trim() !== (initial?.salle || '')
      || nom.trim() !== (initial?.nom || ''));

  return (
    <Feuille visible={visible} titre={t('edt.renommer')} emoji="✏️" hauteur={0.44} onFermer={onFermer}
      action={{ icone: '💾', label: t('commun.enregistrer'), disabled: !modifie,
        onPress: () => onEnregistrer({ nom: nom.trim(), matiere: matiere.trim(), salle: salle.trim() }) }}>
      {/* NOM : champ principal ; matière et salle optionnelles. */}
      <Text style={s.lbl}>{t('edt.nomCreneau')}</Text>
      <TextInput style={s.input} value={nom} onChangeText={setNom} autoFocus
        placeholder={t('edt.phNomCreneau')} placeholderTextColor={UI.faint} />
      <Text style={s.lbl}>{t('edt.matiereOptionnel')}</Text>
      <TextInput style={s.input} value={matiere} onChangeText={setMatiere}
        placeholder={t('edt.phMatiere')} placeholderTextColor={UI.faint} />
      <Text style={s.lbl}>{t('edt.salleOptionnel')}</Text>
      <TextInput style={s.input} value={salle} onChangeText={setSalle}
        placeholder={t('edt.phSalle')} placeholderTextColor={UI.faint} />
    </Feuille>
  );
}

// Styles de formulaire : base partagée du Core (une seule source).
const makeStyles = (UI) => StyleSheet.create({ ...stylesForm(UI) });
